import { Box, Grid2, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { ColorPicker } from 'src/components/NodeSaleForm/ColorPicker';
import { colors } from 'src/global/styles/colors';
import { ProjectInputs } from 'src/global/types/project.type';
import { useTheme } from 'src/provider/ThemeCustomizationProvider';

import { SectionAccordion } from './SectionAccordion';

export function ThemeDataDisplay() {
  const { theme, updateTheme } = useTheme();
  const { watch } = useFormContext<ProjectInputs>();
  const watchReferral = watch('referral');
  return (
    <Box padding={'12px 24px 24px 24px'} borderBottom={`1px solid ${colors.neutral015}`}>
      <SectionAccordion
        title='Data Display'
        bodyContent={
          <Box width={'100%'}>
            <Grid2 container width={'100%'} spacing={3}>
              <Grid2 size={6}>
                <Typography fontSize={'14px'} fontWeight={500} lineHeight={'20px'} sx={{ color: 'white' }}>
                  Container
                </Typography>
                <Typography
                  marginTop={1}
                  fontSize={'12px'}
                  fontWeight={400}
                  lineHeight={'16px'}
                  sx={{ color: colors.neutral90 }}>
                  Background of grouped contents
                </Typography>
                <Box width={'100%'} marginTop={2}>
                  <ColorPicker
                    color={theme.theme.container.color}
                    onColorChange={color => {
                      updateTheme({
                        ...theme,
                        theme: { ...theme.theme, container: { ...theme.theme.container, color: color } },
                      });
                    }}
                    opacity={theme.theme.container.colorOpacity}
                    onOpacityChange={opacity => {
                      updateTheme({
                        ...theme,
                        theme: { ...theme.theme, container: { ...theme.theme.container, colorOpacity: opacity / 100 } },
                      });
                    }}
                  />
                </Box>
              </Grid2>
              {watchReferral.isEnable ? (
                <Grid2 size={6}>
                  <Typography
                    fontSize={'14px'}
                    fontWeight={500}
                    lineHeight={'20px'}
                    sx={{ color: 'white' }}
                    marginBottom={5}>
                    Header row
                  </Typography>
                  <Box width={'100%'} marginTop={2}>
                    <ColorPicker
                      color={theme.theme.headerRow.color}
                      onColorChange={color => {
                        updateTheme({
                          ...theme,
                          theme: { ...theme.theme, headerRow: { ...theme.theme.headerRow, color: color } },
                        });
                      }}
                      opacity={theme.theme.headerRow.colorOpacity}
                      onOpacityChange={opacity => {
                        updateTheme({
                          ...theme,
                          theme: {
                            ...theme.theme,
                            headerRow: { ...theme.theme.headerRow, colorOpacity: opacity / 100 },
                          },
                        });
                      }}
                    />
                  </Box>
                </Grid2>
              ) : null}
            </Grid2>
          </Box>
        }
      />
    </Box>
  );
}
